import React from 'react'
import styled from 'styled-components'
import { mixins, sizes, colors, fonts, breakpoints } from '../../css-variables'
import FeaturedImage from '../../content-blocks/FeaturedImage'
import Title from './Title'
import Excerpt from './Excerpt'
import Byline from './Byline'
import BylineItem from './BylineItem'
import SocialShareLinks from '../SocialShareLinks'
import PostMetaItem from './PostMetaItem'

const hideAuthor = (author) => {
  if (!author) return true
  author = author.toLowerCase()
  return author === 'uwalumni' || author === 'wisconsin alumni association'
}

const TitleSection = ({
  className,
  heading,
  author,
  product,
  date,
  excerpt,
  series,
  event = false,
  smImg,
  size,
  category,
  largeSpace = false,
  shareURL,
}) => {
  const classesList = !event
    ? `${className}`
    : `${className} ${className}--event`
  const largeSpacer = largeSpace ? 'largeSpace' : ''

  return (
    <div className={`${classesList} ${largeSpacer}`}>
      <div className="headersection">
        <Title heading={heading} />
        <div className="titlesection">
          <Excerpt html={excerpt} />
          <div className="titlesection__meta">
            <div className="titlesection__byline">
              <Byline>
                {!hideAuthor(author) && (
                  <BylineItem
                    className={`${className}__author`}
                    item={author}
                  />
                )}
                <BylineItem className={`${className}__date`} item={date} />
                <BylineItem
                  className={`${className}__category`}
                  item={product?.name}
                  url={product?.pages?.nodes[0]?.uri}
                />
                <BylineItem className={`${className}__series`} item={series} />
              </Byline>
              <PostMetaItem
                className="noteCategory"
                prefix="Category"
                item={category?.description ?? undefined}
                url={category?.slug ?? undefined}
              />
            </div>

            {shareURL ? (
              <SocialShareLinks
                text="Share This Story"
                title={heading}
                excerpt={excerpt}
                url={shareURL}
                size={40}
                gtmLocation="top"
              />
            ) : null}
          </div>
        </div>
      </div>
      {smImg && <FeaturedImage featuredImage={smImg} size={size} />}
    </div>
  )
}

const StyledTitleSection = styled(TitleSection)`
  position: relative;
  min-width: 300px;
  width: 80%;
  max-width: 712px;
  margin-left: auto;
  margin-right: auto;
  padding-top: ${sizes.s58};

  @media screen and ${breakpoints.tabletS} {
    padding-top: ${sizes.s45};
  }

  &.largeSpace {
    .headersection {
      margin-bottom: 58px;
    }
  }

  &.header--event {
    min-width: 300px;
    width: 100%;
    padding: 0 ${sizes.s36};

    @media screen and ${breakpoints.tabletS} {
      margin: 0 auto;
      padding: 0;
    }

    @media screen and ${breakpoints.laptopS} {
      margin: 0;
      max-width: 712px;
    }
  }

  h1 {
    color: ${colors.titleColor};
    text-align: left;
    font-family: ${fonts.eaves};
    font-weight: bold;
    font-style: italic;
    font-size: ${sizes.s36};
    line-height: ${sizes.s40};
    width: 100%;
    margin-bottom: 0;

    @media screen and ${breakpoints.laptopS} {
      font-size: ${sizes.s42};
      line-height: ${sizes.s52};
      padding: 0;
    }
  }

  .titlesection {
    text-align: left;
    overflow-wrap: break-word;
    position: relative;
    font-size: ${sizes.s18};
    line-height: ${sizes.s18};
    color: ${colors.copyText};

    .headingexcerpt {
      line-height: ${sizes.s26};
      margin: ${sizes.s24} 0 0 0};
      padding-left: 0px;
      font-size: ${sizes.s16};

      display: block;
      p {
        &:last-child {
          margin-bottom: 0;
        }
        a{
          color:${colors.badgerRed};
        }
      }
    }
    .noteCategory {
      display: block;
      width: 100%;
      margin-top: 12px;
      font-weight: bold;
      color: ${colors.categoryGrey};

      a {
        color: ${colors.categoryGrey};
        text-decoration: none;
        &:visited {
          color: ${colors.categoryGrey};
        }

        &:hover {
          color: ${colors.linkTextHover};
        }
        &:active {
          color: ${colors.linkTextActive};
        }
      }
    }
  }

  &__category {
    color: ${colors.titleColor};
    a {
      color: ${colors.titleColor};
      &:hover {
        color: ${colors.linkTextHover};
      }
      &:active {
        color: ${colors.linkTextActive};
      }
    }
  }

  .headersection {
    ${mixins.headingShortUnderline}
  }

  .titlesection__meta {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > * {
      margin-top: ${sizes.s21};
      align-self: center;
    }

    .socialText {
      font-size: ${sizes.s16};
      line-height: ${sizes.s18};
    }
  }
  

`

export default StyledTitleSection
